import { ProductWorkDto } from "src/dtos/productWork/ProductWorkDto";
import config from "../config";
import { ResponseDto } from "../dtos/common/responseDto";
import { getData } from "../utils/axios/serverHelper";

const baseUrl = `${config.apiUrl}/productWork`;


export const getProductWorkList = async ( searchText:string) => {
	const url = `${baseUrl}/modal`;
	return await getData<ResponseDto<ProductWorkDto[]>>(url, {
		params: {
			searchText
		}
	});
};

export const getProductWorkAllList = async ( searchText:string) => {
	const url = `${baseUrl}/modalAll`;
	return await getData<ResponseDto<ProductWorkDto[]>>(url, {
		params: {
			searchText
		}
	});
};